import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchNew, editNews,
} from "Actions/Admin/Setup/NewsActions";



/**
 * The News Edit Dialog
 */
class NewsEdit extends React.Component {
    // The Initial Data
    initialData = {
        newsID   : 0,
        timeDate : "",
        timeHour : "",
        title    : "",
        text     : "",
        status   : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, fetchNew } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchNew(elemID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition && elemID) {
            data = Utils.extend(this.initialData, elem);
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editNews(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose } = this.props;
        const { data, loading, errors } = this.state;

        return <EditDialog
            open={open}
            icon="news"
            title={!!elemID ? "NEWS_EDIT_TITLE" : "NEWS_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <Columns>
                <InputField
                    type="date"
                    name="timeDate"
                    label="GENERAL_DATE"
                    value={data.timeDate}
                    error={errors.timeDate}
                    onChange={this.handleChange}
                />
                <InputField
                    type="time"
                    name="timeHour"
                    label="GENERAL_HOUR"
                    value={data.timeHour}
                    error={errors.timeHour}
                    onChange={this.handleChange}
                />
            </Columns>
            <InputField
                name="title"
                label="NEWS_TITLE"
                value={data.title}
                error={errors.title}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="textarea"
                name="text"
                label="NEWS_TEXT"
                value={data.text}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="select"
                name="status"
                label="GENERAL_STATUS"
                value={data.status}
                error={errors.status}
                onChange={this.handleChange}
                options={Status.getFemSelect()}
                withNone
                isRequired
                shrinkLabel
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchNew : PropTypes.func.isRequired,
        editNews : PropTypes.func.isRequired,
        open     : PropTypes.bool.isRequired,
        onClose  : PropTypes.func.isRequired,
        onSubmit : PropTypes.func.isRequired,
        edition  : PropTypes.number.isRequired,
        elem     : PropTypes.object.isRequired,
        elemID   : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition : state.news.edition,
            elem    : state.news.elem,
        };
    }
}

export default connect(NewsEdit.mapStateToProps, {
    fetchNew, editNews,
})(NewsEdit);
